import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiRequestsService } from 'src/app/services/api-requests.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { DataManipulateService } from 'src/app/services/data-manipulate.service';

@Component({
  selector: 'app-default-sidebar',
  templateUrl: './default-sidebar.component.html',
  styleUrls: ['./default-sidebar.component.scss']
})
export class DefaultSidebarComponent implements OnInit {

  tempvariable:boolean=false;
  role:string = '';
  param: string = 'Admin';

  constructor(private data:DataManipulateService, private api:ApiRequestsService ,public common:CommonFunctionService,private router: Router){}
  ngOnInit(): void {
    // this.role = this.data.userInfo['userrole'];
    // console.log(this.role),'userrole';
    this.role = this.common.role;  
  }

  togglemini() {
    document.body.classList.toggle('sidebar-mini');
  }

  toAssignPageForAdmin(){
    const url = `/master/customer-referral-master/referral-assign-list?param=${this.param}`;
    this.router.navigateByUrl(url);
  }
  
}
